export default "__VITE_ASSET__D6oh_sV6__"